export const locale = {
  lang: "it",
  data: {
    MENU: {
      COLLABORATOR_USERS_LIST: "Collaboratori",
    },
    ALERT: {
      SUCCESS_DISABLE_TRANSFORMATION: "Trasformazione disabilitata con successo.",
      SUCCESS_RESTORE_TRANSFORMATION: "Trasformazione abilitata con successo.",
      SUCCESS_UPDATE_COLLABORATOR_COST: "Costo collaboratore modificato con successo.",
      ERROR_UPDATE_COLLABORATOR_COST: "Errore nella modifica del costo collaboratore.",
    },
    RELATED_REQUEST: "Richiesta correlata"
  },
};
